import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ontruck/orc';

const t = {
  titles: {
    success: 'Document successfully validated',
    warning: 'Document rejected',
    error: 'There was an error while trying to validate a document',
  },
};

const DocsAlert = ({ className, skin, docType, carrierName, onClose, errorMessage }) => {
  return (
    <div className={className} data-testid="docs-alert">
      <div className="docs-alert">
        <Button
          nude
          icon="close"
          iconPosition="left"
          skin="primary"
          className="docs-alert__close"
          onClick={onClose}
        />
        <h3 className="docs-alert__title">{t.titles[skin]}</h3>
        <div className="docs-alert__type">{docType}</div>
        <div className="docs-alert__carrier">{`for ${carrierName}`}</div>
        <div className="docs-alert__message">{errorMessage}</div>
      </div>
    </div>
  );
};

DocsAlert.defaultProps = {
  className: '',
  skin: 'success',
  errorMessage: '',
  carrierName: '',
  docType: '',
};

DocsAlert.propTypes = {
  className: PropTypes.string,
  carrierName: PropTypes.string,
  docType: PropTypes.string,
  errorMessage: PropTypes.string,
  skin: PropTypes.oneOf(['success', 'warning', 'error']),
  onClose: PropTypes.func.isRequired,
};

export default DocsAlert;
